
  if (!window.backButtonInitialized) {
    window.backButtonInitialized = true;

    // Main back-navigation function
    function handleBackNavigation(event) {
      event.preventDefault();
      
      const button = event.currentTarget;
      const fallbackUrl = button.dataset.fallback || '/';
      
      // Check whether we have history to go back to
      if (window.history.length > 1 && document.referrer) {
        const referrer = new URL(document.referrer);
        const currentHost = window.location.hostname;
        
        // Only use history.back() when the referrer is on the same domain
        if (referrer.hostname === currentHost) {
          window.history.back();
        } else {
          // External referrer — go to the fallback URL
          window.location.href = fallbackUrl;
        }
      } else {
        // No history — go to the fallback URL
        window.location.href = fallbackUrl;
      }
    }

    // Initialize every back button on the page
    function initBackButtons() {
      const backButtons = document.querySelectorAll('[data-back-button]');
      backButtons.forEach(button => {
        if (!button.dataset.initialized) {
          button.addEventListener('click', handleBackNavigation);
          button.dataset.initialized = 'true';
        }
      });
    }

    // Initialize on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBackButtons);
    } else {
      initBackButtons();
    }

    // Re-init after dynamic changes (SPA-friendly)
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length) {
            initBackButtons();
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }